module.exports = __webpack_public_path__ + "static/media/ApercuPro-Black.20da34c6.woff";